import { render, staticRenderFns } from "./Healthy.vue?vue&type=template&id=46394d7b&scoped=true"
import script from "./Healthy.vue?vue&type=script&lang=js"
export * from "./Healthy.vue?vue&type=script&lang=js"
import style0 from "./Healthy.vue?vue&type=style&index=0&id=46394d7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46394d7b",
  null
  
)

export default component.exports